export enum ClickTarget {
  Button = 'Button',
  Link = 'Link',
}
